import { useEffect, useMemo, useRef, useState } from 'react';
import logo from './assets/aecc12_20b2176e47c04a59842e84523d769a90~mv2.png';
import './App.css';

function App() {
  const [stickers, setStickers] = useState([]);
  const headerRef = useRef(null);
  const velocitiesRef = useRef(new Map());
  const lastTimeRef = useRef(null);
  const animationRef = useRef(null);

  const stickerPool = useMemo(() => {
    const contexts = [
      require.context('./assets/752053990', false, /\.png$/),
      require.context('./assets/752053990 2', false, /\.png$/),
      require.context('./assets/752053990 3', false, /\.png$/),
    ];

    return contexts
      .flatMap((context) =>
        context
          .keys()
          .sort((a, b) => {
            const aNum = Number.parseInt(a.replace('./', '').replace('.png', ''), 10);
            const bNum = Number.parseInt(b.replace('./', '').replace('.png', ''), 10);
            return aNum - bNum;
          })
          .map((key) => context(key))
      );
  }, []);

  const handleLogoClick = () => {
    if (!stickerPool.length || !headerRef.current) {
      return;
    }

    const bounds = headerRef.current.getBoundingClientRect();
    const size = 80 + Math.floor(Math.random() * 80);
    const maxX = Math.max(0, bounds.width - size);
    const maxY = Math.max(0, bounds.height - size);
    const x = Math.random() * maxX;
    const y = Math.random() * maxY;
    const rotate = Math.floor(Math.random() * 30) - 15;
    const src = stickerPool[Math.floor(Math.random() * stickerPool.length)];
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

    velocitiesRef.current.set(id, {
      vx: (Math.random() > 0.5 ? 1 : -1) * (140 + Math.random() * 160),
      vy: (Math.random() > 0.5 ? 1 : -1) * (140 + Math.random() * 160),
    });

    setStickers((current) => [
      ...current,
      {
        id,
        src,
        size,
        x,
        y,
        rotate,
      },
    ]);
  };

  useEffect(() => {
    if (!stickers.length || !headerRef.current) {
      return undefined;
    }

    const step = (time) => {
      if (!lastTimeRef.current) {
        lastTimeRef.current = time;
      }
      const delta = (time - lastTimeRef.current) / 1000;
      lastTimeRef.current = time;

      setStickers((current) => {
        if (!current.length || !headerRef.current) {
          return current;
        }

        const bounds = headerRef.current.getBoundingClientRect();

        return current.map((item) => {
          const velocity = velocitiesRef.current.get(item.id);
          if (!velocity) {
            return item;
          }

          const maxX = Math.max(0, bounds.width - item.size);
          const maxY = Math.max(0, bounds.height - item.size);

          let nextX = item.x + velocity.vx * delta;
          let nextY = item.y + velocity.vy * delta;

          if (nextX <= 0) {
            nextX = 0;
            velocity.vx *= -1;
          } else if (nextX >= maxX) {
            nextX = maxX;
            velocity.vx *= -1;
          }

          if (nextY <= 0) {
            nextY = 0;
            velocity.vy *= -1;
          } else if (nextY >= maxY) {
            nextY = maxY;
            velocity.vy *= -1;
          }

          return { ...item, x: nextX, y: nextY };
        });
      });

      animationRef.current = requestAnimationFrame(step);
      return undefined;
    };

    animationRef.current = requestAnimationFrame(step);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      animationRef.current = null;
      lastTimeRef.current = null;
    };
  }, [stickers.length]);

  return (
    <div className="App">
      <header ref={headerRef} className="App-header">
        <button
          type="button"
          className="App-logo-button"
          aria-label="Logo button"
          onClick={handleLogoClick}
        >
          <img src={logo} className="App-logo" alt="logo" />
        </button>
        <p>activate matty</p>
        <div className="Sticker-field" aria-hidden="true">
          {stickers.map((item) => (
            <img
              key={item.id}
              className="Sticker-float"
              src={item.src}
              alt=""
              style={{
                width: `${item.size}px`,
                transform: `translate(${item.x}px, ${item.y}px) rotate(${item.rotate}deg)`,
              }}
            />
          ))}
        </div>
      </header>
    </div>
  );
}

export default App;
